export const SHAREHOLDERS_TAB_SLUGS = [
    'organy-spolki',
    'statut-spolki',
    'walne-zgromadzenia',
    'ogloszenia',
    'akcje-i-kapital',
    'kontakt',
] as const;

export const SHAREHOLDERS_BASE_PATH = '/p/dla-akcjonariuszy/';

export const SHAREHOLDERS_ARCHIVE_TEST_ID_SUFFIX = '-archive';

export const SHAREHOLDERS_FAILURE_MESSAGE =
    'loading shareholders page data from prismic failed';

export const SHAREHOLDERS_TAB_FAILURE_MESSAGE =
    'loading shareholders tab content from prismic failed';
